import React, { useState, useRef, useEffect } from "react";

import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";

import { Table, Input, Button, Tag, Space } from "antd";
import { TextField, Chip, Autocomplete, MenuItem, InputLabel, Popper, Dialog, DialogTitle, DialogContent, DialogActions, RadioGroup, FormControlLabel, Radio, IconButton, StepLabel, Stepper, Step } from "@mui/material";
import {
  PlusOutlined,
  DownloadOutlined,
  EditFilled,
  DeleteFilled,
  FileFilled
} from "@ant-design/icons";

import Select from "react-select";

import CloseIcon from "@mui/icons-material/Close";
const PatientFamilyMember = () => {

  const [showModal, setShowModal] = useState(false);
  const [showModal1, setShowModal1] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const steps = [
    "Basic Info",
    "Emergency",
    "Health Overview",
    "Medications",
    "Family History",
    "Goals",
    "Final Input",
  ];
  const handleNext = () => setActiveStep((prev) => Math.min(prev + 1, steps.length - 1));
  const handleBack = () => setActiveStep((prev) => Math.max(prev - 1, 0));

  const dataSource = [
    {
      key: "1",
      patientId: "PID-001",
      name: "Sarah Johnson",
      relation: "Spouse",
      dob: "05/20/1985",
      gender: "Male",
      bloodGroup: "A+",
      phone: "123-456-7890",
      status: "Inactive",
    },
    {
      key: "2",
      patientId: "PID-002", // 👈 no patient ID
      name: "Emily Johnson",
      relation: "Daughter",
      dob: "02/11/2013",
      gender: "Female",
      bloodGroup: "O+",
      phone: "123-456-7890",
      status: "Active",
    },
  ];
  const allergyOptions = [
    { value: "Nothing", label: "Nothing" },
    { value: "Medication", label: "Medication" },
    { value: "Food", label: "Foode" },
    { value: "Environmental", label: "Environmental" },
    { value: "Other", label: "Other" },
  ];


  const genderOptions = [
    { value: "male", label: "Male" },
    { value: "female", label: "Female" },
    { value: "na", label: "Prefer not to say" },
  ];

  const conditionsOptions = [
    { value: "hypertension", label: "Hypertension" },
    { value: "diabetes", label: "Diabetes" },
    { value: "heart", label: "Heart disease" },
    { value: "asthma", label: "Asthma" },
    { value: "none", label: "None" },
  ];
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text: any, record: any) => (
        <div>
          <div>{text}</div>
          {record.patientId == "PID-002" && (
            <span className="blinker-badge" onClick={() => setShowModal1(true)}>
              Questionnare Pending
            </span>
          )}
        </div>
      ),
    },
    {
      title: "Patient ID",
      dataIndex: "patientId",
      key: "patientId",
      render: (patientId: string | null) =>
        patientId ? (
          patientId
        ) : (
          <span className="pending-blink" onClick={() => setShowModal1(true)}>Pending</span>
        ),
    },


    {
      title: "Relation",
      dataIndex: "relation",
      key: "relation",
    },
    {
      title: "Date of Birth",
      dataIndex: "dob",
      key: "dob",
    },
    {
      title: "Gender",
      dataIndex: "gender",
      key: "gender",
      render: (gender: any) => (
        <Tag color={gender === "Male" ? "green" : "red"}>
          {gender}
        </Tag>
      ),
    },
    {
      title: "Blood Group",
      dataIndex: "bloodGroup",
      key: "bloodGroup",
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status: any) =>
        status === "Active" ? (
          <Tag color="green">Active</Tag>
        ) : (
          <Tag color="red">Inactive</Tag>
        ),
    },
    {
      title: "Action",
      key: "action",
      render: () => (
        <Space>
          <Button

            shape="circle"
            icon={<EditFilled />}
            className="btn-edit"
            onClick={() => setShowModal(true)}
          />
          <Button
            shape="circle"
            icon={<DeleteFilled />}
            className="btn-delete"
          />
          <Button onClick={() => setShowModal1(true)}
            shape="circle"
            icon={<FileFilled />}
            className="small-icon"
          />
        </Space>
      ),
    },
  ];




  const yesNoOptions = [
    { value: "yes", label: "Yes" },
    { value: "no", label: "No" },
  ];


  const supplementsOptions = [
    { value: "vitamins", label: "Vitamins" },
    { value: "herbal", label: "Herbal" },
    { value: "ayurvedic", label: "Ayurvedic" },
    { value: "homeopathic", label: "Homeopathic" },
    { value: "protein", label: "Protein supplements" },
    { value: "none", label: "None" },
  ];

  const familyOptions = [
    { value: "heart", label: "Heart disease" },
    { value: "stroke", label: "Stroke" },
    { value: "diabetes", label: "Diabetes" },
    { value: "cancer", label: "Cancer" },
    { value: "autoimmune", label: "Autoimmune" },
    { value: "mental", label: "Mental health" },
    { value: "dementia", label: "Dementia" },
    { value: "none", label: "None" },
    { value: "not_sure", label: "Not sure" },
  ];

  const goalsOptions = [
    { value: "medication", label: "Medication safety" },
    { value: "symptoms", label: "Symptoms" },
    { value: "chronic", label: "Chronic care" },
    { value: "prevention", label: "Prevention" },
    { value: "lifestyle", label: "Lifestyle" },
    { value: "lab", label: "Lab understanding" },
  ];

  const selectStyles = {
    control: (base: any) => ({
      ...base,
      minHeight: "38px",
      borderColor: "#ced4da",
      boxShadow: "none",
      "&:hover": { borderColor: "#86b7fe" },
    }),
  };


  const stepContents = [
    // Step 0 - Basic Info
    <div className="row g-3">
      <div className="col-md-6">
        <label className="form-label">Full Name</label>
        <input type="text" className="form-control" placeholder="Enter full name" />
      </div>

      <div className="col-md-6">
        <label className="form-label">Date of Birth</label>
        <input type="date" className="form-control" />
      </div>

      <div className="col-md-6">
        <label className="form-label">Sex assigned at birth</label>
        <Select
          styles={{
            ...selectStyles,
            menuPortal: (base) => ({
              ...base,
              zIndex: 1500, // higher than MUI Dialog (default ~1300)
            }),
          }}
          options={genderOptions}

          placeholder="Select"
          menuPortalTarget={document.body}
        />
      </div>

      <div className="col-md-6">
        <label className="form-label">Height</label>
        <input type="text" className="form-control" placeholder="cm or ft/in" />
      </div>

      <div className="col-md-6">
        <label className="form-label">Weight</label>
        <input type="text" className="form-control" placeholder="kg or lbs" />
      </div>

      <div className="col-md-6">
        <label className="form-label">Current Location</label>
        <input type="text" className="form-control" placeholder="Country, State/Region" />
      </div>
    </div>,

    // Step 1 - Emergency
    <div className="row g-3">
      <div className="col-md-6">
        <label className="form-label">Emergency Contact Name</label>
        <input type="text" className="form-control" placeholder="Name" />
      </div>

      <div className="col-md-6">
        <label className="form-label">Relationship</label>
        <input type="text" className="form-control" placeholder="Relationship" />
      </div>

      <div className="col-md-6">
        <label className="form-label">Phone Number</label>
        <input type="tel" className="form-control" placeholder="Phone Number" />
      </div>

      <div className="col-md-6">
        <label className="form-label">
          Can we contact this person in case of a serious health concern?
        </label>
        <Select
          styles={{
            ...selectStyles,
            menuPortal: (base) => ({
              ...base,
              zIndex: 1500, // higher than MUI Dialog (default ~1300)
            }),
          }}
          options={[
            { label: "Yes", value: "yes" },
            { label: "No", value: "no" },
          ]}

          placeholder="Select"
          menuPortalTarget={document.body}
        />
      </div>
    </div>,

    // Step 2 - Health Overview
    <div className="row g-3">
      <div className="col-12">
        <label className="form-label">Diagnosed Conditions</label>
        <Select
          styles={{
            ...selectStyles,
            menuPortal: (base) => ({
              ...base,
              zIndex: 1500, // higher than MUI Dialog (default ~1300)
            }),
          }}
          options={conditionsOptions}
          isMulti

          placeholder="Select conditions"
          menuPortalTarget={document.body}
        />
      </div>

      <div className="col-12">
        <label className="form-label">Allergies</label>
        <Select
          styles={{
            ...selectStyles,
            menuPortal: (base) => ({
              ...base,
              zIndex: 1500, // higher than MUI Dialog (default ~1300)
            }),
          }}
          options={allergyOptions}
          isMulti

          placeholder="Select allergies"
          menuPortalTarget={document.body}
        />
      </div>
    </div>,

    // Step 3 - Medications
    <div className="row g-3">
      <div className="col-md-6">
        <label className="form-label">Currently taking medications?</label>
        <Select
          styles={{
            ...selectStyles,
            menuPortal: (base) => ({
              ...base,
              zIndex: 1500, // higher than MUI Dialog (default ~1300)
            }),
          }}
          options={[
            { label: "Yes", value: "yes" },
            { label: "No", value: "no" },
          ]}

          placeholder="Select"
          menuPortalTarget={document.body}
        />
      </div>

      <div className="col-md-6">
        <label className="form-label">Medication Names</label>
        <input
          type="text"
          className="form-control"
          placeholder="Medication name(s)"
        />
      </div>

      <div className="col-12">
        <label className="form-label">
          Supplements / Non-prescription Remedies
        </label>
        <Select
          styles={{
            ...selectStyles,
            menuPortal: (base) => ({
              ...base,
              zIndex: 1500, // higher than MUI Dialog (default ~1300)
            }),
          }}
          options={supplementsOptions}
          isMulti

          placeholder="Select supplements"
          menuPortalTarget={document.body}
        />
      </div>
    </div>,

    // Step 4 - Family History
    <div className="col-12">
      <label className="form-label">
        Family History (Close family conditions)
      </label>
      <Select
        styles={{
          ...selectStyles,
          menuPortal: (base) => ({
            ...base,
            zIndex: 1500, // higher than MUI Dialog (default ~1300)
          }),
        }}
        options={familyOptions}
        isMulti

        placeholder="Select conditions"
        menuPortalTarget={document.body}
      />
    </div>,

    // Step 5 - Goals
    <div className="col-12">
      <label className="form-label">What would you like help with most?</label>
      <Select
        styles={{
          ...selectStyles,
          menuPortal: (base) => ({
            ...base,
            zIndex: 1500, // higher than MUI Dialog (default ~1300)
          }),
        }}
        options={goalsOptions}
        isMulti

        placeholder="Select up to 3"
        menuPortalTarget={document.body}
      />
    </div>,

    // Step 6 - Final Input
    <div className="col-12">
      <label className="form-label">
        Is there anything you'd like us to know about your health right now?
      </label>
      <textarea
        className="form-control"
        rows={4}
        placeholder="Speak, Type, or Upload"
      />
    </div>,
  ];

  return (
    <div className="content-wrapper">
      <div className="container-full table-padding">

        <div className="page-header">


          <div className="breadcrumb">
            <h3 className="page-title">Family Members</h3>
            <span className="customize-breadcrumb">
              <span className="home-icon">🏠</span>
              <span className="separator"> - </span>
              <span className="current">Family Members</span>
            </span>

          </div>
        </div>
        <div className="family-card">

          {/* Header */}
          <div className="family-header">
            {/* LEFT SIDE */}
            <div className="left-side">
              <p className="title">My Family Members</p>
              <Input placeholder="Search..." className="search-input" />
            </div>

            {/* RIGHT SIDE */}
            <div className="right-side">
              <Space>
                <Button className="btn-add" icon={<PlusOutlined />} onClick={() => setShowModal(true)} />
                <Button className="btn-download" icon={<DownloadOutlined />} />
              </Space>
            </div>
          </div>


          {/* Table */}
          <Table
            columns={columns}
            dataSource={dataSource}
            pagination={false}
            className="family-table"
          />

          {/* Footer */}
          <div className="family-footer">
            Total 90 Patient
          </div>

        </div>
      </div>

      <Dialog
        open={showModal}
        maxWidth="md"
        fullWidth
        className="auth-modal glass-modal"
        onClose={() => setShowModal(false)}
        BackdropProps={{
          style: {
            backgroundColor: "rgba(0, 0, 0, 0.2)",
            backdropFilter: "blur(5px)",
          },
        }}
      >
        {/* HEADER */}
        <DialogTitle className="pt-30 pb-10">
          <h3>New Family Member</h3>
        </DialogTitle>

        {/* CONTENT */}
        <DialogContent className="px-40 pb-30">
          <div className="row g-3">
            {/* Column 1 */}
            <div className="col-md-6">
              <div className="form-group">
                <label className="form-label">Full Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Full Name"
                />
              </div>

              <div className="form-group">
                <label className="form-label">Date of Birth</label>
                <input type="date" className="form-control" />
              </div>

              <div className="form-group">
                <label className="form-label">Blood Group</label>
                <select className="form-select" >
                  <option value="">Select Blood Group</option>
                  <option value="A+">A+</option>
                  <option value="A-">A-</option>
                  <option value="B+">B+</option>
                  <option value="B-">B-</option>
                  <option value="O+">O+</option>
                  <option value="O-">O-</option>
                  <option value="AB+">AB+</option>
                  <option value="AB-">AB-</option>
                </select>
              </div>


              <div className="form-group">
                <label className="form-label">Status</label>
                <select className="form-select">
                  <option>Active</option>
                  <option>Inactive</option>
                </select>
              </div>
            </div>

            {/* Column 2 */}
            <div className="col-md-6">
              <div className="form-group">
                <label className="form-label">Relation</label>
                <select className="form-select">
                  <option>Spouse</option>
                  <option>Son</option>
                  <option>Daughter</option>
                </select>
              </div>

              <div className="form-group">
                <label className="form-label">Assigned at Birth</label>
                <select className="form-select">
                  <option>Male</option>
                  <option>Female</option>
                </select>
              </div>

              <div className="form-group">
                <label className="form-label">Phone Number</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Phone Number"
                />
              </div>

              <div className="form-group">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  className="form-control"
                  placeholder="Email"
                />
              </div>
            </div>
          </div>
        </DialogContent>

        {/* ACTIONS */}
        <DialogActions className="pb-30 px-40 d-flex justify-content-end gap-2">
          <button className="btn btn-warning" onClick={() => setShowModal(false)}>
            Cancel
          </button>

          <button
            className="btn btn-primary"
            onClick={() => {
              setShowConfirm(true)
            }}
          >
            Save
          </button>
        </DialogActions>
      </Dialog>





      <Dialog
        open={showModal1}
        maxWidth="md"
        fullWidth
        className="auth-modal glass-modal"
        onClose={() => setShowModal1(false)}
        BackdropProps={{
          style: { backgroundColor: "rgba(0,0,0,0.2)", backdropFilter: "blur(5px)" },
        }}
      >

        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            pt: 3,
            pb: 5,
          }}
        >
          <h3 style={{ margin: 0 }}>Initial Health Questionnaire</h3>
          <IconButton
            onClick={() => setShowModal1(false)}
            sx={{ color: "red" }} // red color
          >
            <CloseIcon sx={{ color: "gray", "&:hover": { color: "darkred" } }} />
          </IconButton>
        </DialogTitle>

        <DialogContent className="px-4 pb-3">
          <Stepper activeStep={activeStep} alternativeLabel>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>

          <form className="mt-3">{stepContents[activeStep]}</form>
        </DialogContent>

        <DialogActions className="pb-3 px-4 d-flex justify-content-end">

          <button
            className="btn btn-warning"
            disabled={activeStep === 0} onClick={handleBack}
          >
            Back
          </button>

          {activeStep === steps.length - 1 ? (

            <button className="btn btn-primary" onClick={() => setShowModal1(false)}>
              Save
            </button>

          ) : (

            <button className="btn btn-primary" onClick={handleNext}>
              Next
            </button>
          )}



        </DialogActions>
      </Dialog>


      <Dialog
        open={showConfirm}
        maxWidth="sm"
        fullWidth
        className="auth-modal glass-modal"
        onClose={() => setShowConfirm(false)}
        BackdropProps={{
          style: { backgroundColor: "rgba(0,0,0,0.2)", backdropFilter: "blur(5px)" },
        }}
      >
        <DialogTitle className="pt-30 pb-10 text-center">
          <h2>Family Member Added Successfully!</h2>
        </DialogTitle>

        <DialogContent className="px-40 pb-30 text-center">
          <p className="mb-3">
            Please note: To provide complete information, we recommend filling out the health questionnaire form for this family member.
          </p>
          <p className="text-muted fs-14">
            Would you like to fill the questionnaire now?
          </p>
        </DialogContent>

        <DialogActions className="pb-30 px-40 d-flex justify-content-center gap-3">
          <button
            className="btn btn-primary"
            onClick={() => {
              setShowModal(false)
              setShowConfirm(false);
              // setShowModal1(true);
            }}
          >
            Yes
          </button>
          <button
            className="btn btn-secondary"
            onClick={() => {
              setShowConfirm(false);
              setShowModal(false);
              setShowModal1(false);
            }}
          >
            No
          </button>
        </DialogActions>
      </Dialog>



    </div>


  );
};

export default PatientFamilyMember;
